// extracted by mini-css-extract-plugin
module.exports = {"reset":"ResetPassword_reset__2DZ1b","reset__info":"ResetPassword_reset__info__3tl-R","reset__form":"ResetPassword_reset__form__2Suyx"};